namespace $ {

	export class $shm_hitalama_map_component_ready extends $mol_object {

		@ $mol_mem_key
		private static pending( node: $giper_baza_pawn ) { return new $mol_promise_blocker<void>() }

		/** Empty local heads are not evidence that a remote definition is absent. */
		@ $mol_mem_key
		static read( node: $giper_baza_pawn ) {
			if( node.units().length ) return true
			const land = node.land(), yard = node.$.$giper_baza_glob.yard()
			land._gift?.size
			for( const peers of land._sand?.values() ?? [] ) {
				for( const units of peers.values() ) units.size
			}
			const ports = yard.masters()
			if( !ports.length ) return true
			const faces = ports.map( port => yard.face_port_land([ port, land.link() ]) )
			if( !faces.some(Boolean) || faces.some( face => face && [...face].some( ([peer, remote]) => {
				const local = land.faces.get(peer)
				return !local || local.time_tick < remote.time_tick
			}) ) ) $mol_fail_hidden( this.pending( node ) )
			return true
		}

	}

}
